import { render, staticRenderFns } from "./RewardMissionPointLog.vue?vue&type=template&id=31e5c084&"
import script from "./RewardMissionPointLog.vue?vue&type=script&lang=js&"
export * from "./RewardMissionPointLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports